import { render, staticRenderFns } from "./GuestStudentLayout.vue?vue&type=template&id=5295c2d7"
import script from "./GuestStudentLayout.vue?vue&type=script&lang=js"
export * from "./GuestStudentLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports